import React from 'react';

import { flagStyles } from '../settings';

const SvgTW = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5400px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgTW;
